import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider, useAuth } from './context/AuthContext'
import { Layout } from './components/layout/Layout'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { Login } from './pages/Login'
import { Dashboard } from './pages/Dashboard'
import { FindClub } from './pages/FindClub'
import { Profile } from './pages/Profile'
import { Dues } from './pages/Dues'
import { Join } from './pages/Join'
import { Bands } from './pages/Bands'
import { StockBands } from './pages/StockBands'
import { Directory } from './pages/Directory'
import { BandListings } from './pages/BandListings'
import { Races } from './pages/Races'
import { ClubDirectory } from './pages/clubs/ClubDirectory'
import { ClubPage } from './pages/clubs/ClubPage'
import { ClubEditor } from './pages/clubs/ClubEditor'
import { ClaimAccount } from './pages/ClaimAccount'
import { Contact } from './pages/Contact'
import { ForgotPassword } from './pages/ForgotPassword'
import { ResetPassword } from './pages/ResetPassword'
import { Link } from 'react-router-dom'

function HomeRedirect() {
  const { isAuthenticated, isLoading } = useAuth()
  if (isLoading) return null
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
}

function NotFound() {
  return (
    <div className="text-center py-16">
      <h1 className="text-4xl font-heading font-bold text-text mb-4">404</h1>
      <p className="text-text-muted mb-6">Page not found</p>
      <Link to="/" className="text-primary hover:underline">Go to home page</Link>
    </div>
  )
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<Layout />}>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/claim" element={<ClaimAccount />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/join" element={<Join />} />
              <Route path="/find-club" element={<FindClub />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/clubs" element={<ClubDirectory />} />
              <Route path="/clubs/:slug" element={<ClubPage />} />

              {/* Protected routes */}
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/dues" element={<ProtectedRoute><Dues /></ProtectedRoute>} />
              <Route path="/bands" element={<ProtectedRoute><Bands /></ProtectedRoute>} />
              <Route path="/bands/stock" element={<ProtectedRoute><StockBands /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/races" element={<ProtectedRoute><Races /></ProtectedRoute>} />
              <Route path="/directory" element={<ProtectedRoute><Directory /></ProtectedRoute>} />
              <Route path="/band-listings" element={<ProtectedRoute><BandListings /></ProtectedRoute>} />
              <Route path="/clubs/:slug/edit" element={<ProtectedRoute><ClubEditor /></ProtectedRoute>} />

              {/* Root: redirect authenticated users to dashboard, show login for others */}
              <Route path="/" element={<HomeRedirect />} />

              {/* 404 catch-all */}
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  )
}
